import React from "react";
import EmailListManagerForQuotesDesk from "../components/EmailListManagerForQuotesDesk";

export interface IQuotes {
  uuid: string;
  purchaseDate: string;
  isin: string;
  securityName: string;
  securityMaster: null;
  priceHistory: null;
  faceValue: null;
  sellPrice: number;
  image: null;
  securityType: string;
  purchasePrice: number;
  spread: number;
  festival_name_for_quote: string;
  minimumQuantity: string;
  maximumQuantity: string;
  isCurrentDayPurchaseDate: boolean;
  isPushed: boolean;
  purchaseYield: string;
  isBookStock: boolean;
  isHotDeal: boolean;
  isCurrentDay: boolean;
  isPrivatePlacement: boolean;
  valueDate: Date | null;
  sellYield: string;
  percentageCompleted: number;
  insertedAt: Date;
  updatedAt: Date;
}

const QuotesDesk = () => {
  return <EmailListManagerForQuotesDesk />;
};

export default QuotesDesk;
